import styled from "styled-components";
import { colors } from "@/theme";

export const ProductCartDiscountContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 12px 16px;
  align-items: center;
  column-gap: 12px;
`;

export const ProductCartDiscountLabel = styled.div`
  color: ${colors.fieldTextHelper};
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

export const ProductCartDiscountValueContainer = styled.div`
  justify-self: end;
  align-self: center;
`;
